import { useCallback, useEffect, useMemo, useState } from "react";
import { api, mesajEroare } from "./api.js";
import ContorAbonament from "./ContorAbonament.jsx";
import { PreturiNegociate, RegimPreventiv } from "./RegimSiPreturi.jsx";
import { REGIMURI_PREVENTIV, REGIM_PREVENTIV_TOATE, STATUT_CLIENT, eticheta } from "./enums.js";
import { data } from "./text.js";
import { tr } from "./i18n.js";

const ADMINISTRARE = ["ADMIN_TENANT", "MANAGER_TEHNIC"];
const OPERATIONAL = [...ADMINISTRARE, "DISPECER", "COORDONATOR"];

const STATUTE = [
  { cod: "Prospect", titlu: "Prospect" },
  { cod: "Activ", titlu: "Activ" },
  { cod: "Suspendat", titlu: "Suspendat" },
  { cod: "Incheiat", titlu: "Încheiat" },
];

const TIPURI_CONTRACT = [
  { cod: "Mentenanta", titlu: "Mentenanță" },
  { cod: "Garantie", titlu: "Garanție" },
  { cod: "TimeAndMaterial", titlu: "Time & Material" },
  { cod: "Proiect", titlu: "Proiect" },
];

const MODURI_FACTURARE = [
  { cod: "Abonament", titlu: "Abonament" },
  { cod: "PerInterventie", titlu: "Per intervenție" },
  { cod: "Mixt", titlu: "Mixt" },
];

const azi = () => new Date().toISOString().slice(0, 10);

export default function Clienti({ eu }) {
  const [lista, setLista] = useState([]);
  const [cauta, setCauta] = useState("");
  const [aratIncheiati, setAratIncheiati] = useState(false);
  const [alesId, setAlesId] = useState(null);
  const [fisa, setFisa] = useState(null);
  const [incarca, setIncarca] = useState(true);
  const [eroare, setEroare] = useState("");
  const [inrolare, setInrolare] = useState(false);
  const [formLocatie, setFormLocatie] = useState(false);
  const [formContract, setFormContract] = useState(false);

  const poateAdministra = ADMINISTRARE.includes(eu.rol);
  const poateOpera = OPERATIONAL.includes(eu.rol);

  const reincarca = useCallback(async () => {
    setIncarca(true);
    try {
      setLista(await api.clienti({ q: cauta || undefined, inactive: aratIncheiati }));
    } catch (e) {
      setEroare(mesajEroare(e));
    } finally {
      setIncarca(false);
    }
  }, [cauta, aratIncheiati]);

  useEffect(() => { reincarca(); }, [reincarca]);

  const deschide = useCallback(async (id) => {
    setAlesId(id);
    setFisa(null);
    try { setFisa(await api.client(id)); }
    catch (e) { setEroare(mesajEroare(e)); }
  }, []);

  const reincarcaFisa = useCallback(async () => {
    if (alesId) await deschide(alesId);
    await reincarca();
  }, [alesId, deschide, reincarca]);

  return (
    <div className="continut">
      <h1>{tr("Clienți")}</h1>
      <p className="subtitlu">
        {tr("Firma deservită, obiectivele ei și contractele pe care se sprijină termenele și facturarea.")}
      </p>

      {eroare && <div className="eroare">{eroare}</div>}

      <div className="linie-actiune">
        <input
          className="camp camp-cautare"
          placeholder={tr("Caută după denumire, CUI sau oraș…")}
          value={cauta}
          onChange={(e) => setCauta(e.target.value)}
        />
        {poateAdministra && (
          <button className="buton buton-actiune" onClick={() => setInrolare(true)}>
            {tr("Client nou")}
          </button>
        )}
      </div>

      <label className="comutator-dezactivate">
        <input type="checkbox" checked={aratIncheiati} onChange={(e) => setAratIncheiati(e.target.checked)} />
        {tr("arată și clienții încheiați")}
      </label>

      {incarca ? (
        <div className="gol" style={{ padding: "2rem 0" }}>{tr("Se încarcă…")}</div>
      ) : lista.length === 0 ? (
        <div className="panou"><div className="panou-corp gol">
          {cauta ? tr("Niciun client care să se potrivească.") : tr("Niciun client încă. Începe cu „Client nou”.")}
        </div></div>
      ) : (
        <div className="panou">
          <div className="panou-antet">
            <h2>{tr("Clienți")}</h2><span className="numar">{lista.length}</span>
          </div>
          <div className="panou-corp">
            <table className="tabel">
              <thead>
                <tr>
                  <th>{tr("Client")}</th><th>CUI</th><th>{tr("Oraș")}</th><th>{tr("Statut")}</th>
                  <th className="num">{tr("Locații")}</th><th className="num">{tr("Sisteme")}</th>
                  <th className="num">{tr("Echipamente")}</th><th></th>
                </tr>
              </thead>
              <tbody>
                {lista.map((c) => (
                  <tr key={c.id} className={c.statut === "Incheiat" ? "tip-dezactivat" : ""}>
                    <td className="tip-denumire">{tr(c.denumire)}</td>
                    <td><code className="cod-mic">{c.cui || "—"}</code></td>
                    <td>{c.oras || "—"}</td>
                    <td><span className={c.statut === "Activ" ? "eticheta eticheta-activ" : "eticheta"}>{eticheta(STATUT_CLIENT, c.statut)}</span></td>
                    <td className="num">{c.numarLocatii}</td>
                    <td className="num">{c.numarSisteme}</td>
                    <td className="num">{c.numarEchipamente}</td>
                    <td className="celula-actiuni">
                      <button className="buton-mic" onClick={() => deschide(c.id)}>{tr("fișa clientului")}</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {alesId && (
        <FisaClient
          eu={eu}
          fisa={fisa}
          poateAdministra={poateAdministra}
          poateOpera={poateOpera}
          inchide={() => { setAlesId(null); setFisa(null); }}
          adaugaLocatie={() => setFormLocatie(true)}
          adaugaContract={() => setFormContract(true)}
          reincarca={reincarcaFisa}
          setEroare={setEroare}
        />
      )}

      {inrolare && (
        <Inrolare
          inchide={() => setInrolare(false)}
          gata={async (id) => { setInrolare(false); await reincarca(); deschide(id); }}
        />
      )}

      {formLocatie && fisa && (
        <FormLocatie
          clientId={fisa.id}
          inchide={() => setFormLocatie(false)}
          gata={async () => { setFormLocatie(false); await reincarcaFisa(); }}
        />
      )}

      {formContract && fisa && (
        <FormContract
          client={fisa}
          inchide={() => setFormContract(false)}
          gata={async () => { setFormContract(false); await reincarcaFisa(); }}
        />
      )}
    </div>
  );
}

/** Fișa clientului: sisteme, contracte, locații — într-un singur ecran. */
function FisaClient({ eu, fisa, poateAdministra, poateOpera, inchide, adaugaLocatie, adaugaContract, reincarca, setEroare }) {
  const [aratInactive, setAratInactive] = useState(false);
  const [locatii, setLocatii] = useState(null);

  useEffect(() => {
    if (!fisa) return;
    if (!aratInactive) { setLocatii(null); return; }
    api.locatii(fisa.id, true).then(setLocatii).catch((e) => setEroare(mesajEroare(e)));
  }, [aratInactive, fisa, setEroare]);

  if (!fisa) {
    return (
      <div className="modal-fundal" onClick={inchide}>
        <div className="modal modal-lat" onClick={(e) => e.stopPropagation()}>
          <div className="gol" style={{ padding: "2rem" }}>{tr("Se încarcă fișa…")}</div>
        </div>
      </div>
    );
  }

  const dePrezentat = aratInactive && locatii ? locatii : fisa.locatii;

  const comuta = async (locatie) => {
    try {
      await api.comutaLocatie(locatie.id, !locatie.activ);
      await reincarca();
      if (aratInactive) setLocatii(await api.locatii(fisa.id, true));
    } catch (e) { setEroare(mesajEroare(e)); }
  };

  return (
    <div className="modal-fundal" onClick={inchide}>
      <div className="modal modal-lat" onClick={(e) => e.stopPropagation()}>
        <h2>{tr(fisa.denumire)}</h2>
        <p className="subtitlu">
          {[fisa.cui, [fisa.adresa, fisa.oras, fisa.judet].filter(Boolean).join(", ")]
            .filter(Boolean).join(" · ") || tr("Fără date de identificare completate.")}
        </p>

        {fisa.persoaneContact?.length > 0 && (
          <div className="panou">
            <div className="panou-antet"><h2>{tr("Persoane de contact")}</h2></div>
            <div className="panou-corp">
              {fisa.persoaneContact.map((p) => (
                <div key={p.id} className="rezultat-context">
                  <strong>{p.nume}</strong>
                  {p.functie && ` — ${p.functie}`}
                  {p.telefon && ` · ${p.telefon}`}
                  {p.email && ` · ${p.email}`}
                  {p.principal && <span className="marcaj">{tr("principal")}</span>}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="panou">
          <div className="panou-antet">
            <h2>{tr("Locații")}</h2>
            <span className="numar">{dePrezentat.length}</span>
            {poateAdministra && (
              <button className="buton-mic" onClick={adaugaLocatie}>{tr("adaugă locație")}</button>
            )}
          </div>
          <div className="panou-corp">
            <label className="comutator-dezactivate">
              <input type="checkbox" checked={aratInactive} onChange={(e) => setAratInactive(e.target.checked)} />
              {tr("arată și locațiile dezactivate")}
            </label>
            {dePrezentat.length === 0 ? (
              <div className="gol">{tr("Nicio locație.")}</div>
            ) : (
              <table className="tabel">
                <thead>
                  <tr><th>{tr("Locație")}</th><th>{tr("Adresă")}</th><th>{tr("Program de acces")}</th>
                      <th className="num">{tr("Sisteme")}</th><th></th></tr>
                </thead>
                <tbody>
                  {dePrezentat.map((l) => (
                    <tr key={l.id} className={l.activ === false ? "tip-dezactivat" : ""}>
                      <td className="tip-denumire">
                        {tr(l.denumire)}
                        {l.activ === false && <span className="eticheta eticheta-inactiv">{tr("dezactivată")}</span>}
                      </td>
                      <td>{[l.adresa, l.oras].filter(Boolean).join(", ") || "—"}</td>
                      <td>{l.programAcces || "—"}</td>
                      <td className="num">{l.numarSisteme ?? "—"}</td>
                      <td className="celula-actiuni">
                        {poateAdministra && (
                          <button className="buton-mic" onClick={() => comuta(l)}>
                            {l.activ === false ? tr("reactivează") : tr("dezactivează")}
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        <div className="panou">
          <div className="panou-antet">
            <h2>{tr("Contracte")}</h2>
            <span className="numar">{fisa.contracte.length}</span>
            {poateAdministra && (
              <button className="buton-mic" onClick={adaugaContract}>{tr("adaugă contract")}</button>
            )}
          </div>
          <div className="panou-corp">
            {fisa.contracte.length === 0 ? (
              <div className="gol">
                {tr("Niciun contract. Fără contract activ, tichetele intră pe regim Time & Material, fără termen garantat.")}
              </div>
            ) : (
              <table className="tabel">
                <thead>
                  <tr><th>{tr("Număr")}</th><th>{tr("Tip")}</th><th>{tr("Valabil")}</th><th>{tr("Facturare")}</th>
                      <th>{tr("Acoperire")}</th><th></th></tr>
                </thead>
                <tbody>
                  {fisa.contracte.map((c) => (
                    <tr key={c.id} className={!c.activ || c.expirat ? "tip-dezactivat" : ""}>
                      <td className="tip-denumire"><code className="cod-mic">{c.numar}</code></td>
                      <td>{tr(TIPURI_CONTRACT.find((t) => t.cod === c.tip)?.titlu) ?? c.tip}</td>
                      <td>
                        {data(c.valabilDeLa)} → {data(c.valabilPanaLa)}
                        {c.expirat && <span className="eticheta eticheta-inactiv">{tr("expirat")}</span>}
                        {!c.expirat && c.zilePanaLaExpirare != null && c.zilePanaLaExpirare <= 60 && (
                          <span className="marcaj" title={tr("Expiră curând")}>{c.zilePanaLaExpirare} {tr("zile")}</span>
                        )}
                      </td>
                      <td>
                        {tr(MODURI_FACTURARE.find((m) => m.cod === c.modFacturare)?.titlu) ?? c.modFacturare}
                        {c.valoareAbonamentLunar && ` · ${c.valoareAbonamentLunar} ${c.moneda}/lună`}
                      </td>
                      <td>
                        {c.locatii?.length ? (c.locatii.length === 1 ? tr("o locație") : tr("{0} locații", c.locatii.length)) : tr("toate locațiile")}
                        {c.sisteme?.length ? ` · ${c.sisteme.map((s) => s.tipSistem.cod).join(", ")}` : ""}
                      </td>
                      <td className="celula-actiuni">
                        {poateAdministra && (
                          <button className="buton-mic" onClick={async () => {
                            try { await api.comutaContract(c.id, !c.activ); await reincarca(); }
                            catch (e) { setEroare(mesajEroare(e)); }
                          }}>{c.activ ? tr("dezactivează") : tr("reactivează")}</button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        <RegimPreventiv client={fisa} />

        <ContorAbonament eu={eu} client={fisa} contracte={fisa.contracte} />

        <PreturiNegociate eu={eu} client={fisa} />

        <div className="modal-actiuni">
          <button className="buton buton-discret" onClick={inchide}>{tr("închide")}</button>
        </div>
      </div>
    </div>
  );
}

/**
 * Înrolarea, în trei pași. Se trimite ca o SINGURĂ cerere la final: dacă pică
 * ceva, nu rămâne un client pe jumătate creat, care apoi trebuie reparat de
 * mână în bază.
 */
function Inrolare({ inchide, gata }) {
  const [pas, setPas] = useState(1);
  const [client, setClient] = useState({ denumire: "", cui: "", adresa: "", oras: "", judet: "", email: "", telefon: "" });
  const [contact, setContact] = useState({ nume: "", functie: "", telefon: "", email: "" });
  const [locatii, setLocatii] = useState([{ denumire: "", adresa: "", oras: "", programAcces: "" }]);
  const [cuContract, setCuContract] = useState(true);
  const [contract, setContract] = useState({
    numar: "", tip: "Mentenanta", valabilDeLa: azi(), valabilPanaLa: "",
    modFacturare: "Abonament", valoareAbonamentLunar: "",
    numarVizitePreventivePeAn: "", frecventaPreventivaLuni: "",
    // Nicio valoare implicită: regimul se ALEGE. Altfel „fără preventiv" ar
    // arăta iar la fel cu „n-a apucat nimeni să completeze".
    regimPreventiv: "", preventivRefuzatMotiv: "",
  });
  const [salvez, setSalvez] = useState(false);
  const [eroare, setEroare] = useState("");

  const locatiiValide = locatii.filter((l) => l.denumire.trim());
  const potContinua = pas === 1 ? client.denumire.trim().length >= 2
    : pas === 2 ? true
    : !cuContract || contract.numar.trim().length > 0;

  const trimite = async () => {
    setSalvez(true); setEroare("");
    try {
      const corp = {
        client: Object.fromEntries(Object.entries(client).filter(([, v]) => String(v).trim())),
        ...(contact.nume.trim()
          ? { persoaneContact: [{ ...Object.fromEntries(Object.entries(contact).filter(([, v]) => String(v).trim())), principal: true }] }
          : {}),
        ...(locatiiValide.length
          ? { locatii: locatiiValide.map((l) => Object.fromEntries(Object.entries(l).filter(([, v]) => String(v).trim()))) }
          : {}),
        ...(cuContract && contract.numar.trim()
          ? {
              contract: {
                numar: contract.numar.trim(),
                tip: contract.tip,
                valabilDeLa: new Date(contract.valabilDeLa).toISOString(),
                ...(contract.valabilPanaLa ? { valabilPanaLa: new Date(contract.valabilPanaLa).toISOString() } : {}),
                modFacturare: contract.modFacturare,
                ...(contract.valoareAbonamentLunar ? { valoareAbonamentLunar: Number(contract.valoareAbonamentLunar) } : {}),
                ...(contract.numarVizitePreventivePeAn ? { numarVizitePreventivePeAn: Number(contract.numarVizitePreventivePeAn) } : {}),
                ...(contract.frecventaPreventivaLuni ? { frecventaPreventivaLuni: Number(contract.frecventaPreventivaLuni) } : {}),
              },
            }
          : {}),
      };
      const creat = await api.inroleazaClient(corp);
      await gata(creat.id);
    } catch (e) {
      setEroare(mesajEroare(e));
      setSalvez(false);
    }
  };

  return (
    <div className="modal-fundal" onClick={inchide}>
      <div className="modal modal-lat" onClick={(e) => e.stopPropagation()}>
        <h2>{tr("Client nou — pasul")} {pas} {tr("din 3")}</h2>
        <p className="subtitlu">
          {pas === 1 && "Firma și persoana cu care se vorbește."}
          {pas === 2 && "Obiectivele unde se lucrează. Le poți adăuga și mai târziu."}
          {pas === 3 && "Contractul pe care se sprijină termenele și facturarea."}
        </p>

        {eroare && <div className="eroare">{eroare}</div>}

        {pas === 1 && (
          <>
            <div className="formular-linie">
              <label>{tr("Denumire")}<input className="camp" value={client.denumire}
                onChange={(e) => setClient({ ...client, denumire: e.target.value })} autoFocus /></label>
              <label>CUI<input className="camp" value={client.cui}
                onChange={(e) => setClient({ ...client, cui: e.target.value })} /></label>
            </div>
            <div className="formular-linie">
              <label>{tr("Adresă")}<input className="camp" value={client.adresa}
                onChange={(e) => setClient({ ...client, adresa: e.target.value })} /></label>
              <label>{tr("Oraș")}<input className="camp" value={client.oras}
                onChange={(e) => setClient({ ...client, oras: e.target.value })} /></label>
              <label>{tr("Județ")}<input className="camp" value={client.judet}
                onChange={(e) => setClient({ ...client, judet: e.target.value })} /></label>
            </div>
            <div className="formular-linie">
              <label>{tr("Persoană de contact")}<input className="camp" value={contact.nume}
                onChange={(e) => setContact({ ...contact, nume: e.target.value })} /></label>
              <label>{tr("Funcție")}<input className="camp" value={contact.functie}
                onChange={(e) => setContact({ ...contact, functie: e.target.value })} /></label>
              <label>{tr("Telefon")}<input className="camp" value={contact.telefon}
                onChange={(e) => setContact({ ...contact, telefon: e.target.value })} /></label>
            </div>
          </>
        )}

        {pas === 2 && (
          <>
            {locatii.map((l, i) => (
              <div className="formular-linie" key={i}>
                <label>{tr("Locație")} {i + 1}<input className="camp" value={l.denumire}
                  onChange={(e) => setLocatii(locatii.map((x, j) => j === i ? { ...x, denumire: e.target.value } : x))} /></label>
                <label>{tr("Adresă")}<input className="camp" value={l.adresa}
                  onChange={(e) => setLocatii(locatii.map((x, j) => j === i ? { ...x, adresa: e.target.value } : x))} /></label>
                <label>{tr("Program de acces")}<input className="camp" placeholder={tr("L–V 08–17")} value={l.programAcces}
                  onChange={(e) => setLocatii(locatii.map((x, j) => j === i ? { ...x, programAcces: e.target.value } : x))} /></label>
              </div>
            ))}
            <button className="buton-discret" onClick={() => setLocatii([...locatii, { denumire: "", adresa: "", oras: "", programAcces: "" }])}>
              {tr("+ încă o locație")}
            </button>
          </>
        )}

        {pas === 3 && (
          <>
            <label className="linie-bifa">
              <input type="checkbox" checked={cuContract} onChange={(e) => setCuContract(e.target.checked)} />
              {tr("clientul are contract")}
            </label>
            {!cuContract ? (
              <p className="nota-cautare">
                {tr("Fără contract, tichetele lui intră pe regim Time & Material, fără termen garantat. Poți adăuga contractul oricând, din fișa clientului.")}
              </p>
            ) : (
              <>
                <div className="formular-linie">
                  <label>{tr("Număr")}<input className="camp" value={contract.numar}
                    onChange={(e) => setContract({ ...contract, numar: e.target.value })} /></label>
                  <label>{tr("Tip")}<select className="camp" value={contract.tip}
                    onChange={(e) => setContract({ ...contract, tip: e.target.value })}>
                    {TIPURI_CONTRACT.map((t) => <option key={t.cod} value={t.cod}>{tr(t.titlu)}</option>)}
                  </select></label>
                </div>
                <div className="formular-linie">
                  <label>{tr("Valabil de la")}<input className="camp" type="date" value={contract.valabilDeLa}
                    onChange={(e) => setContract({ ...contract, valabilDeLa: e.target.value })} /></label>
                  <label>{tr("până la")}<input className="camp" type="date" value={contract.valabilPanaLa}
                    onChange={(e) => setContract({ ...contract, valabilPanaLa: e.target.value })} /></label>
                </div>
                <div className="formular-linie">
                  <label>{tr("Facturare")}<select className="camp" value={contract.modFacturare}
                    onChange={(e) => setContract({ ...contract, modFacturare: e.target.value })}>
                    {MODURI_FACTURARE.map((m) => <option key={m.cod} value={m.cod}>{tr(m.titlu)}</option>)}
                  </select></label>
                  <label>{tr("Abonament lunar")}<input className="camp" type="number" min="0" value={contract.valoareAbonamentLunar}
                    onChange={(e) => setContract({ ...contract, valoareAbonamentLunar: e.target.value })} /></label>
                  <label>{tr("Vizite preventive / an")}<input className="camp" type="number" min="0" value={contract.numarVizitePreventivePeAn}
                    onChange={(e) => setContract({ ...contract, numarVizitePreventivePeAn: e.target.value })} /></label>
                </div>
                <p className="nota-cautare">
                  {tr("Contractul acoperă implicit toate locațiile definite la pasul 2.")}
                </p>
              </>
            )}
          </>
        )}

        <div className="modal-actiuni">
          <button className="buton buton-discret" onClick={inchide} disabled={salvez}>{tr("renunță")}</button>
          {pas > 1 && <button className="buton buton-discret" onClick={() => setPas(pas - 1)} disabled={salvez}>{tr("înapoi")}</button>}
          {pas < 3
            ? <button className="buton buton-adauga" onClick={() => setPas(pas + 1)} disabled={!potContinua}>{tr("mai departe")}</button>
            : <button className="buton buton-adauga" onClick={trimite} disabled={!potContinua || salvez}>
                {salvez ? tr("se creează…") : tr("creează clientul")}
              </button>}
        </div>
      </div>
    </div>
  );
}

function FormLocatie({ clientId, inchide, gata }) {
  const [d, setD] = useState({ denumire: "", adresa: "", oras: "", judet: "", tara: "", programAcces: "", instructiuniAcces: "" });
  const [eroare, setEroare] = useState("");
  const [salvez, setSalvez] = useState(false);

  const salveaza = async () => {
    setSalvez(true); setEroare("");
    try {
      await api.creeazaLocatie(clientId, Object.fromEntries(Object.entries(d).filter(([, v]) => String(v).trim())));
      await gata();
    } catch (e) { setEroare(mesajEroare(e)); setSalvez(false); }
  };

  return (
    <div className="modal-fundal" onClick={inchide}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{tr("Locație nouă")}</h2>
        {eroare && <div className="eroare">{eroare}</div>}
        <label>{tr("Denumire")}<input className="camp" value={d.denumire} autoFocus
          onChange={(e) => setD({ ...d, denumire: e.target.value })} /></label>
        <label>{tr("Adresă")}<input className="camp" value={d.adresa}
          onChange={(e) => setD({ ...d, adresa: e.target.value })} /></label>
        <div className="formular-linie">
          <label>{tr("Oraș")}<input className="camp" value={d.oras}
            onChange={(e) => setD({ ...d, oras: e.target.value })} /></label>
          <label>{tr("Județ")}<input className="camp" value={d.judet}
            onChange={(e) => setD({ ...d, judet: e.target.value })} /></label>
          {/*
            Țara obiectivului decide pachetul de țară — moneda, cota de TVA,
            fusul pe care se măsoară termenele, sărbătorile legale. Până acum
            nu o cerea nimeni, iar coloana se umplea singură cu „RO": un
            obiectiv din altă țară primea tăcut regimul românesc.
          */}
          <label>{tr("Țara")}<input className="camp" maxLength={2}
            placeholder={tr("ca la firmă")} value={d.tara}
            onChange={(e) => setD({ ...d, tara: e.target.value.toUpperCase() })} /></label>
        </div>
        <p className="nota-cautare" style={{ marginTop: "-.4rem" }}>
          {tr("Țara obiectivului decide moneda, cota de TVA, fusul pe care se măsoară termenele și sărbătorile legale. Lăsată goală, se ia țara firmei.")}
        </p>
        <label>{tr("Program de acces")}<input className="camp" placeholder={tr("L–V 08–17, sâmbăta cu anunț")}
          value={d.programAcces} onChange={(e) => setD({ ...d, programAcces: e.target.value })} /></label>
        <label>{tr("Instrucțiuni de acces")}<textarea className="camp" rows={3}
          placeholder={tr("Poarta 2, se sună la dispecerat. Cheia de la camera tehnică e la șeful de tură.")}
          value={d.instructiuniAcces} onChange={(e) => setD({ ...d, instructiuniAcces: e.target.value })} /></label>
        <div className="modal-actiuni">
          <button className="buton buton-discret" onClick={inchide}>{tr("renunță")}</button>
          <button className="buton buton-adauga" onClick={salveaza} disabled={!d.denumire.trim() || salvez}>
            {salvez ? tr("se salvează…") : tr("salvează")}
          </button>
        </div>
      </div>
    </div>
  );
}

function FormContract({ client, inchide, gata }) {
  const [d, setD] = useState({
    numar: "", tip: "Mentenanta", valabilDeLa: azi(), valabilPanaLa: "",
    modFacturare: "Abonament", valoareAbonamentLunar: "",
    numarVizitePreventivePeAn: "", frecventaPreventivaLuni: "",
  });
  const [locatiiAlese, setLocatiiAlese] = useState([]);
  const [eroare, setEroare] = useState("");
  const [salvez, setSalvez] = useState(false);

  const active = useMemo(() => client.locatii.filter((l) => l.activ !== false), [client.locatii]);

  const salveaza = async () => {
    // Regimul de preventiv nu e un câmp printre altele: contractul îl declară
    // sau nu se scrie. Oprirea se face aici ca omul să vadă motivul lângă
    // câmpul lui, nu ca un refuz venit de la server fără context.
    if (!d.regimPreventiv) {
      setEroare(tr("Alege regimul de mentenanță preventivă, așa cum e scris în contractul semnat."));
      return;
    }
    if (d.regimPreventiv === "FaraPreventiv" && d.preventivRefuzatMotiv.trim().length < 10) {
      setEroare(tr("Scrie de ce clientul nu vrea preventiv. O bifă fără motiv n-ar valora nimic exact în ziua în care ai avea nevoie de ea."));
      return;
    }
    setSalvez(true); setEroare("");
    try {
      await api.creeazaContract(client.id, {
        numar: d.numar.trim(), tip: d.tip,
        valabilDeLa: new Date(d.valabilDeLa).toISOString(),
        ...(d.valabilPanaLa ? { valabilPanaLa: new Date(d.valabilPanaLa).toISOString() } : {}),
        modFacturare: d.modFacturare,
        ...(d.valoareAbonamentLunar ? { valoareAbonamentLunar: Number(d.valoareAbonamentLunar) } : {}),
        ...(d.numarVizitePreventivePeAn ? { numarVizitePreventivePeAn: Number(d.numarVizitePreventivePeAn) } : {}),
        ...(d.frecventaPreventivaLuni ? { frecventaPreventivaLuni: Number(d.frecventaPreventivaLuni) } : {}),
        regimPreventiv: d.regimPreventiv,
        ...(d.regimPreventiv === "FaraPreventiv" && d.preventivRefuzatMotiv.trim()
          ? { preventivRefuzatMotiv: d.preventivRefuzatMotiv.trim() } : {}),
        ...(locatiiAlese.length ? { locatiiIds: locatiiAlese } : {}),
      });
      await gata();
    } catch (e) { setEroare(mesajEroare(e)); setSalvez(false); }
  };

  return (
    <div className="modal-fundal" onClick={inchide}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{tr("Contract nou —")} {tr(client.denumire)}</h2>
        {eroare && <div className="eroare">{eroare}</div>}
        <div className="formular-linie">
          <label>{tr("Număr")}<input className="camp" value={d.numar} autoFocus
            onChange={(e) => setD({ ...d, numar: e.target.value })} /></label>
          <label>{tr("Tip")}<select className="camp" value={d.tip} onChange={(e) => setD({ ...d, tip: e.target.value })}>
            {TIPURI_CONTRACT.map((t) => <option key={t.cod} value={t.cod}>{tr(t.titlu)}</option>)}
          </select></label>
        </div>
        <div className="formular-linie">
          <label>{tr("Valabil de la")}<input className="camp" type="date" value={d.valabilDeLa}
            onChange={(e) => setD({ ...d, valabilDeLa: e.target.value })} /></label>
          <label>{tr("până la")}<input className="camp" type="date" value={d.valabilPanaLa}
            onChange={(e) => setD({ ...d, valabilPanaLa: e.target.value })} /></label>
        </div>
        <div className="formular-linie">
          <label>{tr("Facturare")}<select className="camp" value={d.modFacturare}
            onChange={(e) => setD({ ...d, modFacturare: e.target.value })}>
            {MODURI_FACTURARE.map((m) => <option key={m.cod} value={m.cod}>{tr(m.titlu)}</option>)}
          </select></label>
          <label>{tr("Abonament lunar")}<input className="camp" type="number" min="0" value={d.valoareAbonamentLunar}
            onChange={(e) => setD({ ...d, valoareAbonamentLunar: e.target.value })} /></label>
        </div>
        <div className="panou panou-atentie"><div className="panou-corp">
          <label>
            {tr("Mentenanță preventivă, conform contractului semnat")} *
            <select className="camp" value={d.regimPreventiv}
              onChange={(e) => setD({ ...d, regimPreventiv: e.target.value })}>
              <option value="">{tr("— alege —")}</option>
              {Object.entries(REGIMURI_PREVENTIV).map(([v, t]) => (
                <option key={v} value={v}>{tr(t)}</option>
              ))}
            </select>
          </label>

          {d.regimPreventiv === "FaraPreventiv" && (
            <label>
              {tr("De ce nu vrea clientul preventiv (se tipărește în dosarul de conformitate)")}
              <textarea className="camp" rows={2} value={d.preventivRefuzatMotiv}
                placeholder={tr("ex. A refuzat în scris la negocierea din 12 august; și-a asumat riscul.")}
                onChange={(e) => setD({ ...d, preventivRefuzatMotiv: e.target.value })} />
            </label>
          )}

          {d.regimPreventiv === "InclusInAbonament" && (
            <label>
              {tr("Câte cicluri pe an include abonamentul")}
              <input className="camp" type="number" min="1" value={d.numarVizitePreventivePeAn}
                onChange={(e) => setD({ ...d, numarVizitePreventivePeAn: e.target.value })} />
            </label>
          )}

          <p className="subtitlu" style={{ marginBottom: 0 }}>
            {tr("„Fără preventiv\" se poate — clientul își asumă. Dar se consemnează cu motiv, cu numele tău și cu data: la un control, diferența dintre „clientul a refuzat\" și „am uitat noi\" e diferența dintre problema lui și problema ta.")}
          </p>
        </div></div>

        {active.length > 0 && (
          <>
            <p className="nota-cautare">
              {tr("Locații acoperite. Niciuna bifată înseamnă toate — util pentru contractul-cadru.")}
            </p>
            {active.map((l) => (
              <label key={l.id} className="linie-bifa">
                <input type="checkbox" checked={locatiiAlese.includes(l.id)}
                  onChange={(e) => setLocatiiAlese(e.target.checked
                    ? [...locatiiAlese, l.id]
                    : locatiiAlese.filter((x) => x !== l.id))} />
                {tr(l.denumire)}
              </label>
            ))}
          </>
        )}
        <div className="modal-actiuni">
          <button className="buton buton-discret" onClick={inchide}>{tr("renunță")}</button>
          <button className="buton buton-adauga" onClick={salveaza} disabled={!d.numar.trim() || salvez}>
            {salvez ? tr("se salvează…") : tr("salvează")}
          </button>
        </div>
      </div>
    </div>
  );
}

export { STATUTE };
